import { forwardRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from './Button';
import styles from './Input.module.scss';

const Input = forwardRef(
  (
    {
      label,
      placeholder,
      onChange,
      classes,
      className,
      value,
      inputIcon,
      onValueSubmit,
      showWrapper,
      type,
      autocomplete,
      labelId,
      ...props
    },
    ref,
  ) => {
    const handleChange = (value) => onChange && onChange(value);

    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        onValueSubmit && onValueSubmit(value);
      }
    };

    return (
      <div className={classNames(styles['input-container'], { [styles['input-container--wrapping']]: showWrapper }, className)}>
        <input
          ref={ref}
          aria-label={label}
          placeholder={placeholder}
          className={classNames(styles['input'], classes.input)}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          value={value}
          type={type}
          autoComplete={autocomplete}
          {...props}
        />
        {inputIcon?.length > 0 &&
          inputIcon.map(({ icon, onClick, label, ...props }, i) => (
            <Button
              key={i}
              style={{ font: 'initial', background: 'none' }}
              icon={icon}
              focus="outline"
              onClick={(e) => onClick && onClick(e)}
              classes={{ icon: classNames(styles['icon'], classes.icon) }}
              screenReaderText={label}
              {...props}
            />
          ))}
      </div>
    );
  },
);
Input.displayName = 'Input';

Input.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onValueSubmit: PropTypes.func,
  classes: PropTypes.shape({
    input: PropTypes.string,
  }),
  className: PropTypes.string,
  showWrapper: PropTypes.bool,
  inputIcon: PropTypes.arrayOf(PropTypes.shape({ icon: PropTypes.node, onClick: PropTypes.func })),
  type: PropTypes.string,
  autocomplete: PropTypes.string,
};

Input.defaultProps = {
  placeholder: '',
  classes: {},
  showWrapper: true,
  type: 'text',
};

export { Input as default, Input };
